module.exports = __webpack_public_path__ + "img/marker-alt-complete.svg?70ac253c62b49ed33c5ff905a6cd3505";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maps/marker-alt-complete.svg
// module id = 301
// module chunks = 0